import { useSelector } from 'react-redux'
import { notifications, notificationsInitialized } from 'notification/redux/selectors'
import { Notification } from 'notification/interfaces'

export const useNotifications = () => useSelector(notifications) as Notification[]
export const useNotificationsInitialized = () => useSelector(notificationsInitialized) as boolean
